import qs from 'qs';
import axios from 'axios'
import { Endpoint, mkEndpoint } from '~/plugins/req/Scalar'

export const Resource = class {
    
    // _endpoint: '',
    
    // _version: 'api',
    
    // _leaderUrl: '',
    
    // __id: '',
    
    // _axios: axios,
    
    // // _cache = {}

    // _status: false,

    constructor(endpoint, $axios, version = 'api') {
        this._endpoint = mkEndpoint(endpoint, '端点')
        this._version = version
        this._axios = $axios || axios.create({})
        this._leaderUrl = version 
            ? `/${version}/${this._endpoint.value}` 
            : `/${this._endpoint.value}`   // ${version}/
        this._status = version === 'api'
    }

    async selects(params) {
        return await this._axios.get(this._leaderUrl, params && {params})
    }
    
    async deletes(data) {
        return await this._axios.post(this._leaderUrl, this._status ? 
            data : 
            qs.stringify(data))
    }
    
    async updates(data) {
        return await this._axios.post(this._leaderUrl, data)
    }
    
    async create(data) {
        return await this._axios.post(this._leaderUrl, data)
    }

    async delete(id) {
        return await this._axios.delete(`${this._leaderUrl}/${id}`)
    }

    async select(id, params) {
        // return await this._axios.get(`${this._leaderUrl}/${id}`, this._status ? 
        //     params && {params} : 
        //     qs.stringify(params && {params}))
        return await this._axios.get(`${this._leaderUrl}/${id}`, params && {params})
    }

    async update(id, r) {
        let q = this._axios.post(`${this._leaderUrl}/${id}`, r)
        return await q
    }

    _ (id) {
        this.__id = id
        return this
    }

    concat(R) {
        let endpoint = this.__id
                     ? `${this._endpoint.value}/${this.__id}/${R._endpoint.value}`
                     : `${this._endpoint.value}/${R._endpoint.value}`
        return new Resource(endpoint, this._axios, this._version)
    }
}

/**
 * 拼接请求参数 url 路径
 * 发起请求后端数据
 * @param endpoint 请求 URL 和 参数
 * ```
 * # demo1
 *  ...ServicesR = requestStart('indices/nav')
 *  // indices/nav
 * # demo2
 * ...ServicesR = requestStart('indices/nav/100')
 *  // indices/nav/100
 * # demo3
 * ...ServicesR = requestStart({path: 'indices/nav'})
 *  // indices/nav
 * # demo4
 * ...ServicesR = requestStart({path: 'indices/nav', params: '100'})
 *  // indices/nav/100
 * # demo5
 * ...ServicesR = requestStart({path: 'indices/nav', params: {cid: 100, gid: 123}})
 *  // indices/nav/cid/100/gid/123
 * ```
 * @param version
 */
const requestStart = (endpoint, version = 'api', tokenKey = 'authUser/info/AccessToken') => {
    return ($axios = axios.create({}), query) => {
        let endpointPath = endpoint
        if (Object(query) === query || Object(endpoint) === endpoint) {
            let querys = Object.assign({path: '', params: {}, header: {}}
                                        , query || {}
                                        ,  ['string', 'number'].indexOf(typeof endpoint) > -1 
                                            ? {path: endpoint}
                                            : endpoint)
            for (let headkey in querys.header) {
                $axios.defaults.headers.common[headkey] = querys.header[headkey]
            }
            let param = new Array();
            switch (typeof querys.params) {
                case 'string':
                case 'number':
                    param.push(querys.params)
                    break;
                case 'object':
                    for (var key in querys.params) {
                        Array.isArray(querys.params) 
                            ? param.push(querys.params[key])
                            : param.push(key, querys.params[key])
                    }
            }
            endpointPath = [querys.path, param.filter(x => x).join('/')].filter(x => x).join('/')
        }
        return new Resource(endpointPath, $axios, version)
    }
}

export default requestStart
export {requestStart}


// WEBPACK FOOTER //
// ./plugins/req/Resource.js